'use strict';

var _ = require('lodash'),
    inventory = require('./'),
    progress = require('../progress'),
    ajax = require('../ajax');

var newLine = '\n';
var pdpStoreTemplate = function (store) {
    return [
        '<li class="store-list-item ' + (store.storeId === User.storeId ? ' selected' : '') + '">',
        '    <div class="store-address">' + store.address1 + ', ' + store.city + ' ' + store.stateCode +
        ' ' + store.postalCode + '</div>',
        '    <div class="store-status" data-status="' + store.statusclass + '">' + store.status + '</div>',
        '</li>'
    ].join(newLine);
};
var pdpStoresListingTemplate = function (stores) {
    if (stores && stores.length) {
        return [
            '<div class="store-list-pdp-container">',
            (stores.length > 1 ? '    <a class="stores-toggle collapsed" href="#">' + Resources.SEE_MORE + '</a>' : ''),
            '    <ul class="store-list-pdp">',
            _.map(stores, pdpStoreTemplate).join(newLine),
            '    </ul>',
            '</div>'
        ].join(newLine);
    }
};

var storesListing = function (stores) {
    // list all stores on PDP page
    if ($('.store-list-pdp-container').length) {
        $('.store-list-pdp-container').remove();
    }
    $('.availability-results').append(pdpStoresListingTemplate(stores));
};

var productInventory = {
    setPreferredStore: function (storeId) {
        User.storeId = storeId;
        $.ajax({
            url: Urls.setPreferredStore,
            type: 'POST',
            data: {storeId: storeId}
        });
    },
    productSelectStore: function () {
        var self = this;
        inventory.getStoresInventory(this.pid).then(function (stores) {
            inventory.selectStoreDialog({
                stores: stores,
                selectedStoreId: User.storeId,
                selectedStoreText: Resources.PREFERRED_STORE,
                continueCallback: storesListing,
                selectStoreCallback: self.setPreferredStore
            });
        }).done();
    },
    init: function () {
        var $availabilityContainer = $('.availability-results'),
            self = this;
        this.pid = $('input[name="pid"]').val();

        $('#product-content .set-preferred-store').on('click', function (e) {
            e.preventDefault();
            if (!User.zip) {
                inventory.zipPrompt(function () {
                    self.productSelectStore();
                });
            } else {
                self.productSelectStore();
            }
        });

        if ($availabilityContainer.length) {
            if (User.storeId) {
                inventory.getStoresInventory(this.pid).then(storesListing);
            }

            // See more or less stores in the listing
            $availabilityContainer.on('click', '.stores-toggle', function (e) {
                e.preventDefault();
                $('.store-list-pdp .store-list-item').toggleClass('visible');
                if ($(this).hasClass('collapsed')) {
                    $(this).text(Resources.SEE_LESS_STORE);
                } else {
                    $(this).text(Resources.SEE_MORE);
                }
                $(this).toggleClass('collapsed'); 
            });
        }
    }
};

$('.tabs .tab-header').click(function(){
    var tab_id = $(this).data('tab');
    $('.tabs .tab-header').removeClass('current');
    $('.tabs .tab-header').attr('aria-selected','false');
	$('.tab-content').removeClass('current');
    $(this).addClass('current');
    $('.tabs .tab-header.current').attr('aria-selected','true');
    $("#"+tab_id).addClass('current');
    /*if ($('.pdp-main.standardproduct').length !== 0 && (tab_id === 'tab-5' || tab_id === 'tab-7')) {
        var url = Urls.getProductReviews;
        var contentLoaded = false;
        var targetElement = $('.review-section .tab-content-details');
        if (tab_id === 'tab-5') {
            var contentLength = $("#TurnToReviewsContent").html().length;
            if (contentLength > 0) {
                contentLoaded = true;
            }
            if ($('.review-section .tab-content-details').length !== 0 && $('.review-section .tab-content-details').has($('div')).length === 0) {
                progress.show($('.review-section .tab-content-details'));
            }
            targetElement = $('.review-section .tab-content-details');
        }
        else if (tab_id == 'tab-7') {
            var contentLength = $("#TurnToContent").html().length;
            if (contentLength > 0) {
                contentLoaded = true;
            }
            url = Urls.getProductQA;
            if ($('.qanda-section .tab-content-details').length !== 0 && $('.qanda-section .tab-content-details').has($('div')).length === 0) {
                progress.show($('.qanda-section .tab-content-details'));
            }
            targetElement = $('.qanda-section .tab-content-details');
        }

        if (!contentLoaded) {
            var pid = $('input[name="pid"]').val();
            if (pid.indexOf('-') > -1) {
                pid = $('input[name="mpid"]').val();
            }
            ajax.load({
                url: url,
                data: 'pid=' + pid,
                target: targetElement,
                callback: function (){
                    TurnTo.initialize();
                }
            })
        }
    };*/

});


$('body').on('click','.thumb.slick-slide',function(e){
	if($(this).data('slick-index')==0 && $(this).hasClass("selected")){
		$('.product-primary-image .b_product_badge').removeClass("js-hide").addClass("js-show");
	}
	else {
		$('.product-primary-image .b_product_badge').removeClass("js-show").addClass("js-hide");
    }
});

$('body').on('click','.video-link',function(e){
	if($(this).data('slick-index')==0 && $(this).hasClass("selected")){
		$('.product-primary-image .b_product_badge').removeClass("js-hide").addClass("js-show");
	}
	else {
		$('.product-primary-image .b_product_badge').removeClass("js-show").addClass("js-hide");
    }
});

// on click review counts on PDP navigates to review tab section.
$('body').on('click','.turntofitcounts, .TTreviewcount',function(e){ 
    
	if($('.product-info .tabs, .tabs-set-prod .tab').length) {
		var $fixedHeader = $('.fixed-header').outerHeight();
    	$('html, body').animate({ scrollTop: $('.product-info .tabs, .tabs-set-prod .tab').offset().top - $fixedHeader}, 700);
    	$('.tabs .review-heading').trigger('click');
    }
});

$('body').on('keypress','.prod-detail-page .inventory .custom-select .quantityinput', function (e) {
	var $mac = navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i) ? true : false;
	if($mac && e.which === 13){
		e.preventDefault();
	}	
});

module.exports = productInventory;
